import "./Card.css";
import React from 'react';
  
const Card = ({ title, content, stats }) => { 
       return (
        <div className='card'>
            <div className='card-title'>
                <h2>{title}</h2>
            </div>
            <div className='card-content'>
                 {content}
              </div>
              <div className='card-stats'>
                 <p>{stats}</p>
              </div>
        </div>
 
       ); 
};
 
export default Card; 